import { BelongItemList } from '../models/BelongItemList'
import { BelongItemStatus } from '../models/BelongItemStatus'

export function filterItemsByStatus(
  items: BelongItemList,
  status: BelongItemStatus
): BelongItemList {
  if (status === 'ALL') {
    return items
  }
  return items.filter((item) => item.status === status)
}
